module.exports = __webpack_public_path__ + "static/media/shell32_161.9d924007.ico";